import React, { Component } from "react";
import {
  Tooltip,
  Button,
  Icon,
  Modal,
  Table,
  message,
  Form,
  Select,
  Input,
  Checkbox,
  Spin,
  Divider,
  DatePicker,
} from "antd";
import HospitalModal from "./hospitalModal";
import {
  selectHospitalList,
  roleMenuList,
  deleteHospital,
  addHospital,
  getSecondGroupList,
  getFirstGroupList,
  getHospitalItem,
} from "@/request/api";
import "./index.scss";
import moment from "moment";
import { requestErrorLog } from "@/common/util";

const { Option } = Select;
const { TextArea } = Input;
const { confirm } = Modal;
class SettingHospital extends Component {
  state = {
    tableData: [],
    modalTitle: "",
    rowData: "",
    hospitalVisible: false,
    powerMenuList: [], // 菜单权限
    menuName: [],
    menuname: [],
    menuid: [],
    hospitalName: "",
    PageNo: 1,
    PageSize: 10,
    RowCount: 0,
    hospitalType: [
      { label: "申请医院", value: 1 },
      { label: "会诊医院", value: 2 },
    ],
    typeArr: [],
    groupingArr: [
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
    ],
    firstGroupList: [],
    secondGroupList: [],
    selectFirstGroup: "",
    showAdditionalInfo: 0,
    hospitalItemList: [],
  };

  hospitalColumns = [
    {
      title: "医院编码",
      dataIndex: "HOSPITAL_CODE",
      key: "HOSPITAL_CODE",
      width: 100,
      align: "center",
    },
    {
      title: "医院等级",
      dataIndex: "HOSPITAL_LEVEL",
      key: "HOSPITAL_LEVEL",
      width: 100,
      align: "center",
    },
    {
      title: "医院类型",
      dataIndex: "IS_APPLY_HOSPITAL",
      key: "IS_APPLY_HOSPITAL",
      width: 150,
      render: (text, record, index) => {
        return (
          <p>
            <span>{record.IS_APPLY_HOSPITAL ? "申请医院" : ""}&nbsp;</span>
            <span>{record.IS_CONSULATION_HOSPITAL ? "会诊医院" : ""}</span>
          </p>
        );
      },
    },
    {
      title: "医院名称",
      dataIndex: "HOSPITAL_NAME",
      key: "HOSPITAL_NAME",
      width: 350,
      ellipsis: true,
      render: (text) => {
        return (
          <Tooltip placement="topLeft" title={text}>
            <span>{text}</span>
          </Tooltip>
        );
      },
    },
    {
      title: "医院电话",
      dataIndex: "HOSPITAL_TEL",
      key: "HOSPITAL_TEL",
      width: 120,
    },
    {
      title: "医院地址",
      dataIndex: "HOSPITAL_ADDRESS",
      key: "HOSPITAL_ADDRESS",
      ellipsis: true,
      width: 320,
      render: (text) => {
        return (
          <Tooltip placement="topLeft" title={text}>
            <span>{text}</span>
          </Tooltip>
        );
      },
    },
    {
      title: "医院简介",
      dataIndex: "HOSPITAL_DESCRIPTION",
      key: "HOSPITAL_DESCRIPTION",
      ellipsis: true,
      width: 320,
      render: (text) => {
        return (
          <Tooltip placement="topLeft" title={text}>
            <span>{text}</span>
          </Tooltip>
        );
      },
    },
  ];

  componentDidMount() {
    this.hospitalList();
    this.permissionList();
    this.getFirstGroupList();
    this.getHospitalItemFn();
  }

  getHospitalItemFn = () => {
    getHospitalItem().then((res) => {
      if (res && res.Status === 1) {
        this.setState({
          hospitalItemList: res.Result,
        });
      } else {
        requestErrorLog("", "权限管理-医院管理-获取检查项目列表报错", 0, true);
      }
    });
  };
  hospitalList = () => {
    // 获取医院列表
    this.setState({ tabsloading: true });
    let params = {
      Type: "SELECTHospitalHK",
      HOSPITAL_NAME: this.state.hospitalName,
      PageNo: this.state.PageNo,
      PageSize: this.state.PageSize,
      USER_UID: JSON.parse(localStorage.getItem("userInfo")).USER_UID || "",
    };
    selectHospitalList(params).then((res) => {
      if (res && res.Status === 1) {
        const data = res.Result.dataInfo;
        let RowCount = res.Result.pageInfo.RowCount;
        this.setState({
          tableData: data,
          tabsloading: false,
          RowCount,
        });
      } else {
        requestErrorLog("", "权限管理-医院管理-获取医院列表报错", 0, true);
      }
    });
  };
  //获取一级组别列表
  getFirstGroupList = async () => {
    let res = await getFirstGroupList();
    if (res && res.Status === 1) {
      this.setState({
        firstGroupList: res.Result,
      });
    } else {
      requestErrorLog("", "权限管理-医院管理-获取一级组别列表报错", 0, true);
    }
  };
  //获取二级组别列表
  getSecondGroupList = async (firstGrouping) => {
    let firstGroupListId = firstGrouping || this.props.form.getFieldValue("firstGrouping");
    if (!firstGroupListId || firstGroupListId.length === 0) {
      this.setState({ secondGroupList: [] });
      this.props.form.setFieldsValue({ secondGrouping: undefined });
      return;
    }
    this.deleteSecondGroups(firstGrouping);
    this.setState({ selectFirstGroup: firstGroupListId.toString() });
    let res = await getSecondGroupList(firstGroupListId.toString());
    if (res && res.Status === 1) {
      this.setState({
        secondGroupList: res.Result,
      });
    } else {
      requestErrorLog("", "权限管理-医院管理-获取二级组别列表报错", 0, true);
    }
  };
  //删除了一级组别，相对应的二级组别也一块删掉
  deleteSecondGroups = (first) => {
    let secondGroupIds = this.props.form.getFieldValue("secondGrouping");
    let secondGroupList = this.state.secondGroupList;
    if (secondGroupIds && secondGroupIds.length > 0) {
      let newSecondGroupList = this.getGroupInfo(secondGroupIds, secondGroupList);
      let i = 0;
      while (i < newSecondGroupList.length) {
        let firstId = newSecondGroupList[i].FIRST_GROUP_CODE;
        let index = first.findIndex((item) => item === firstId);
        if (index === -1) {
          newSecondGroupList.splice(i, 1);
          secondGroupIds.splice(i, 1);
        } else {
          i++;
        }
      }
      this.props.form.setFieldsValue({ secondGrouping: secondGroupIds });
    }
  };
  permissionList = () => {
    // 获取权限列表
    roleMenuList().then((res) => {
      if (res && res.Status === 1) {
        const MenuList = res.Result.MenuList;
        let result = [];
        MenuList.forEach((item) => {
          result.push({
            value: item.PRIVILEGE_UID,
            label: item.PRIVILEGE_NAME,
          });
        });
        this.setState({
          powerMenuList: result,
        });
      } else {
        requestErrorLog("", "权限管理-医院管理-获取权限列表报错", 0, true);
      }
    });
  };

  handleAddHospital = () => {
    //  新增
    this.props.form.resetFields(); //清空form中每条数据
    this.setState({
      isModalVisible: true,
      modalTitle: "add",
      rowData: "",
    });
  };

  handleEditHospital = () => {
    // 修改
    this.props.form.resetFields(); //清空form中每条数据
    let rowData = this.state.rowData;
    this.getSecondGroupList(rowData.FIRST_GROUP_CODE);
    if (rowData.MENUMODULE && !Array.isArray(rowData.MENUMODULE)) {
      rowData.MENUMODULE = rowData.MENUMODULE.split(",");
      rowData.MENUMODULE_UID = rowData.MENUMODULE_UID.split(",");
    }
    let typeArr = [];
    if (rowData.IS_APPLY_HOSPITAL) {
      typeArr.push(1);
    }
    if (rowData.IS_CONSULATION_HOSPITAL) {
      typeArr.push(2);
    }
    if (this.state.rowData) {
      this.setState({
        isModalVisible: true,
        modalTitle: "edit",
        rowData,
        menuname: rowData.MENUMODULE || [],
        menuid: rowData.MENUMODULE_UID || [],
        typeArr,
      });
    } else {
      message.warning("请先选择要操作的数据");
    }
  };

  handleDeleteHospital = () => {
    // 删除
    const { rowData } = this.state;
    let userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    if (!rowData) {
      message.warning("请选择要操作的数据");
    } else {
      confirm({
        title: "删除操作",
        content: "医院如果被删除，该医院下的科室和用户都会被删除，是否确认删除？",
        onOk: () => {
          let params = {
            Type: "DELETE",
            HOSPITAL_UID: rowData.HOSPITAL_UID,
            USER_UID: userInfo.USER_UID,
          };
          deleteHospital(params).then((res) => {
            if (res && res.Status === 1) {
              if (res.Result === -2) {
                message.error("操作人与添加人需一致！");
                return;
              }
              message.success("删除成功！");
              this.setState({ rowData: "" });
              this.hospitalList();
            } else {
              requestErrorLog("", "权限管理-医院管理-删除医院报错", 0, true);
              message.error("删除失败！");
            }
          });
        },
      });
    }
  };

  handleSettingHosKey = () => {
    const { rowData } = this.state;
    if (!rowData) {
      message.warning("请先选择要操作的数据");
    } else {
      if (!rowData.IS_APPLY_HOSPITAL) {
        return message.error("该医院不能设置权限");
      }
      this.setState({
        hospitalVisible: true,
      });
    }
  };

  onClickRow = (record) => {
    return {
      onClick: () => {
        this.setState({
          rowData: record,
        });
      },
    };
  };
  setRowClassName = (record) => {
    return record === this.state.rowData ? "clickRowStyl" : "";
  };

  // 处理过滤历史权限管理name
  getFilterMenuname = (menuname, powerMenuList) => {
    return menuname.filter((item) => {
      const index = powerMenuList.findIndex((powerItem) => powerItem.label === item);
      return index > -1;
    });
  };

  // 处理过滤历史权限管理id
  getFilterMenuid = (menuid, powerMenuList) => {
    return menuid.filter((item) => {
      const index = powerMenuList.findIndex((powerItem) => powerItem.value === item);
      return index > -1;
    });
  };

  getIsPrivilege = (values, applyHospital, consultHospital, hospitalitem) => {
    let userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    const { rowData, menuname, menuid, powerMenuList } = this.state;
    let Param = {
      Type: "HospitalEDITHK", // 修改
      Module_Name: this.getFilterMenuname(menuname, powerMenuList),
      Module_Uid: this.getFilterMenuid(menuid, powerMenuList),
    };
    let RequestModel = {
      hospitalinfo: {
        HOSPITAL_UID: rowData.HOSPITAL_UID,
        HOSPITAL_NAME: values.HOSPITAL_NAME,
        HOSPITAL_CODE: rowData.HOSPITAL_CODE,
        HOSPITAL_TEL: values.HOSPITAL_TEL,
        IS_APPLY_HOSPITAL: applyHospital,
        IS_CONSULATION_HOSPITAL: consultHospital,
        HOSPITAL_LEVEL: values.HOSPITAL_LEVEL,
        STATISTICAL_TYPE: values.STATISTICAL_TYPE,
        HOSPITAL_ADDRESS: values.HOSPITAL_ADDRESS,
        HOSPITAL_DESCRIPTION: values.HOSPITAL_DESCRIPTION,
        BELONG_GROUP: values.BELONG_GROUP,
        FIRST_GROUP_CODE: values.firstGrouping.toString(),
        SECOND_GROUP_CODE: values.secondGrouping.toString(),
        SEQUENCE_ANALYSIS: Number(values.SEQUENCE_ANALYSIS),
        EDIT_UID: userInfo.USER_UID,
      },
      additionalinfo: {
        MEDICAL_CONTACT: values.MEDICAL_CONTACT,
        MEDICAL_TEL: values.MEDICAL_TEL,
        DEALER_CONTACT: values.DEALER_CONTACT,
        DEALER_TEL: values.DEALER_TEL,
        ECG_INSTALL_DATE: values.ECG_INSTALL_DATE?.format("YYYY-MM-DD"),
        BP_INSTALL_DATE: values.BP_INSTALL_DATE?.format("YYYY-MM-DD"),
        HOLTER_INSTALL_DATE: values.HOLTER_INSTALL_DATE?.format("YYYY-MM-DD"),
        ECG_WITHDRAWAL_DATE: values.ECG_WITHDRAWAL_DATE?.format("YYYY-MM-DD"),
        BP_WITHDRAWAL_DATE: values.BP_WITHDRAWAL_DATE?.format("YYYY-MM-DD"),
        HOLTER_WITHDRAWAL_DATE: values.HOLTER_WITHDRAWAL_DATE?.format("YYYY-MM-DD"),
        ECG_RELOCATION_DATE: values.ECG_RELOCATION_DATE?.format("YYYY-MM-DD"),
        ECG_RELOCATION_PLACE: values.ECG_RELOCATION_PLACE,
        BP_RELOCATION_DATE: values.BP_RELOCATION_DATE?.format("YYYY-MM-DD"),
        BP_RELOCATION_PLACE: values.BP_RELOCATION_PLACE,
        HOLTER_RELOCATION_DATE: values.HOLTER_RELOCATION_DATE?.format("YYYY-MM-DD"),
        HOLTER_RELOCATION_PLACE: values.HOLTER_RELOCATION_PLACE,
        ADDITIONAL_UID: rowData.ADDITIONAL_DATA?.ADDITIONAL_UID,
      },
      hospitalitem,
    };
    let isPass = this.checkGroup(values.firstGrouping, values.secondGrouping);
    if (!isPass) return;
    addHospital(Param, RequestModel).then((res) => {
      if (res && res.Status === 1) {
        if (res.Result === -2) {
          message.error("医院名称不能相同！");
          return;
        }
        if (res.Result === -4) {
          message.error("编辑人与添加人需相同！");
          return;
        }
        if (res.Result === -5) {
          message.error("找不到该条数据！");
          return;
        }
        this.setState({ rowData: "" });
        this.handleCancel();
        this.hospitalList();
        message.success("修改成功!");
      } else {
        requestErrorLog("", "权限管理-医院管理-修改医院报错", 0, true);
        message.error("修改失败!");
      }
    });
  };
  //判断选择的一级和二级分组是否符合要求，选择了一级组别就必须要选择相对应的二级组别
  checkGroup = (first, second) => {
    const { firstGroupList, secondGroupList } = this.state;
    let secondGroups = this.getGroupInfo(second, secondGroupList);
    let falg = true;
    first.forEach((code) => {
      let hasSecond = secondGroups.find((item) => item.FIRST_GROUP_CODE === code);
      if (!hasSecond) {
        let name = firstGroupList.find((item) => item.FIRST_GROUP_CODE === code).FIRST_GROUP_NAME;
        message.error(`请选择 ${name} 的二级组别`);
        falg = false;
        return falg;
      }
    });
    return falg;
  };
  //根据选择的分组id获取到所有二级的分组信息
  getGroupInfo = (id, list) => {
    let res = [];
    id.forEach((group) => {
      let secondGroup = list.find((item) => group === item.SECOND_GROUP_CODE);
      if (secondGroup) res.push(secondGroup);
    });
    return res;
  };
  handleHospitalInfo = () => {
    const { menuname, menuid, modalTitle, powerMenuList } = this.state;
    let userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    this.props.form.validateFields((err, values) => {
      let IS_APPLY_HOSPITAL = 0,
        IS_CONSULATION_HOSPITAL = 0;
      if (values.type.indexOf(1) !== -1) {
        IS_APPLY_HOSPITAL = 1;
      }
      if (values.type.indexOf(2) !== -1) {
        IS_CONSULATION_HOSPITAL = 1;
      }
      if (!err) {
        let hospitalitem = [];
        values.HOSPITAL_ITEM_DATA.forEach((item) => {
          let temp = this.state.hospitalItemList.filter((i) => item === i.EXAM_ITEM_CODE);
          if (temp.length > 0) {
            hospitalitem.push(temp[0]);
          }
        });
        if (modalTitle === "add") {
          let Param = {
            Type: "HospitalADDHK", // 新增
            Module_Name: this.getFilterMenuname(menuname, powerMenuList),
            Module_Uid: this.getFilterMenuid(menuid, powerMenuList),
          };
          let RequestModel = {
            hospitalinfo: {
              HOSPITAL_UID: values.HOSPITAL_UID,
              HOSPITAL_NAME: values.HOSPITAL_NAME,
              HOSPITAL_TEL: values.HOSPITAL_TEL,
              IS_APPLY_HOSPITAL: IS_APPLY_HOSPITAL,
              IS_CONSULATION_HOSPITAL: IS_CONSULATION_HOSPITAL,
              HOSPITAL_LEVEL: values.HOSPITAL_LEVEL,
              HOSPITAL_ADDRESS: values.HOSPITAL_ADDRESS,
              STATISTICAL_TYPE: values.STATISTICAL_TYPE,
              HOSPITAL_DESCRIPTION: values.HOSPITAL_DESCRIPTION,
              BELONG_GROUP: values.BELONG_GROUP,
              FIRST_GROUP_CODE: values.firstGrouping.toString(),
              SECOND_GROUP_CODE: values.secondGrouping.toString(),
              SEQUENCE_ANALYSIS: Number(values.SEQUENCE_ANALYSIS), // 1是 0否
              CREATE_UID: userInfo.USER_UID,
            },
            additionalinfo: {
              MEDICAL_CONTACT: values.MEDICAL_CONTACT,
              MEDICAL_TEL: values.MEDICAL_TEL,
              DEALER_CONTACT: values.DEALER_CONTACT,
              DEALER_TEL: values.DEALER_TEL,
              ECG_INSTALL_DATE: values.ECG_INSTALL_DATE?.format("YYYY-MM-DD"),
              BP_INSTALL_DATE: values.BP_INSTALL_DATE?.format("YYYY-MM-DD"),
              HOLTER_INSTALL_DATE: values.HOLTER_INSTALL_DATE?.format("YYYY-MM-DD"),
              ECG_WITHDRAWAL_DATE: values.ECG_WITHDRAWAL_DATE?.format("YYYY-MM-DD"),
              BP_WITHDRAWAL_DATE: values.BP_WITHDRAWAL_DATE?.format("YYYY-MM-DD"),
              HOLTER_WITHDRAWAL_DATE: values.HOLTER_WITHDRAWAL_DATE?.format("YYYY-MM-DD"),
              ECG_RELOCATION_DATE: values.ECG_RELOCATION_DATE?.format("YYYY-MM-DD"),
              ECG_RELOCATION_PLACE: values.ECG_RELOCATION_PLACE,
              BP_RELOCATION_DATE: values.BP_RELOCATION_DATE?.format("YYYY-MM-DD"),
              BP_RELOCATION_PLACE: values.BP_RELOCATION_PLACE,
              HOLTER_RELOCATION_DATE: values.HOLTER_RELOCATION_DATE?.format("YYYY-MM-DD"),
              HOLTER_RELOCATION_PLACE: values.HOLTER_RELOCATION_PLACE,
            },
            hospitalitem: hospitalitem,
          };
          let isPass = this.checkGroup(values.firstGrouping, values.secondGrouping);
          if (!isPass) return;
          addHospital(Param, RequestModel).then((res) => {
            if (res && res.Status === 1) {
              if (res.Result === -2) {
                message.error("医院名称不能相同！");
                return;
              }
              this.handleCancel();
              message.success("新增成功！");
              this.hospitalList();
            } else {
              requestErrorLog("", "权限管理-医院管理-新增医院报错", 0, true);
              message.error("新增失败！");
            }
          });
        }
        if (modalTitle === "edit") {
          this.getIsPrivilege(values, IS_APPLY_HOSPITAL, IS_CONSULATION_HOSPITAL, hospitalitem);
        }
      }
    });
  };

  handleCheckbox = (checkedValues) => {
    const { powerMenuList } = this.state;
    const menuName = [];
    const menuId = [];
    powerMenuList.forEach((item) => {
      if (checkedValues.indexOf(item.value) > -1) {
        menuName.push(item.label);
        menuId.push(item.value);
      }
    });
    this.setState({
      menuname: menuName,
      menuid: menuId,
    });
  };

  handleCancel = () => {
    this.setState({
      isModalVisible: false,
      showAdditionalInfo: 0,
      menuname: [],
      menuid: [],
      typeArr: [],
    });
  };

  //医院类型更改
  hospitalTypeChange = (value) => {
    this.setState({
      typeArr: value,
    });
    console.log(value);
    if (value.length !== 2) {
      let STATISTICAL_TYPE = value.indexOf(1) !== -1 ? "申请医院" : "会诊医院";
      this.props.form.setFieldsValue({
        STATISTICAL_TYPE,
      });
    }
  };

  //医院名称搜索
  handlehospitalName = (e) => {
    this.setState({
      hospitalName: e.target.value,
    });
  };

  handleHospitalList = () => {
    this.setState(
      {
        PageNo: 1,
        PageSize: 10,
      },
      () => {
        this.hospitalList();
      }
    );
  };

  changeFocus = (e) => {
    if (e.keyCode === 13) {
      this.handleHospitalList();
    }
  };
  changePageFn = (PageNo) => {
    this.setState(
      {
        PageNo,
      },
      () => {
        this.hospitalList();
      }
    );
  };
  onAdditionalInfoClose = () => {
    this.setState({ showAdditionalInfo: 0 });
  };
  onAdditionalInfoShow = () => {
    if (this.state.showAdditionalInfo === 0) {
      this.setState({ showAdditionalInfo: 780 });
    } else {
      this.setState({ showAdditionalInfo: 0 });
    }
  };
  clearDatePicker = (key) => {
    this.props.form.setFieldsValue({ [key]: undefined });
  };
  render() {
    const { tabsloading, tableData, modalTitle, powerMenuList, isModalVisible, hospitalVisible, rowData, typeArr } =
      this.state;
    const { getFieldDecorator } = this.props.form;
    return (
      <>
        <div className="btnStyle" style={{ marginBottom: "10px" }}>
          <Button onClick={() => this.handleAddHospital()}>
            <Icon type="plus-circle" />
            添加
          </Button>
          <Button onClick={() => this.handleEditHospital()}>
            <Icon type="minus-circle" />
            修改
          </Button>
          <Button onClick={() => this.handleDeleteHospital()}>
            <Icon type="close-circle" />
            删除
          </Button>
          <Button onClick={this.handleSettingHosKey}>
            <Icon type="key" />
            医院权限
          </Button>
        </div>
        <Form layout="inline" className="searchBox">
          <Form.Item label="医院名称">
            <Input
              allowClear
              value={this.state.hospitalName}
              onChange={this.handlehospitalName}
              onKeyDown={this.changeFocus}
            />
          </Form.Item>
          <Button onClick={this.handleHospitalList}>查询</Button>
        </Form>
        {/* 医院权限 */}
        {hospitalVisible ? (
          <HospitalModal
            visible={hospitalVisible}
            rowData={rowData}
            onRef={(ref) => {
              this.setState({ hospitalVisible: ref });
            }}
          />
        ) : null}
        <Spin size="large" spinning={tabsloading} tip="Loading...">
          <Table
            size="middle"
            scroll={{ x: 900, scrollToFirstRowOnChange: true }} // 730 + 申请号
            columns={this.hospitalColumns}
            dataSource={tableData}
            rowKey={(record) => record.HOSPITAL_UID} // 需要修改为唯一的ID！
            bordered={true}
            pagination={{
              total: this.state.RowCount,
              current: this.state.PageNo,
              onChange: this.changePageFn,
            }}
            onRow={this.onClickRow}
            rowClassName={this.setRowClassName}
          />
        </Spin>

        {isModalVisible ? (
          <Modal
            title={
              <div className="patient_title">
                <img alt="" src={require("@/assets/image/ecg.png").default} className="addIcon" />
                <span>{modalTitle === "add" ? "添加医院" : "编辑医院"}</span>
              </div>
            }
            className={this.state.showAdditionalInfo === 0 ? "hospitalModal" : "hospitalModalTranslate"}
            visible={isModalVisible}
            maskClosable={false}
            onOk={this.handleHospitalInfo}
            onCancel={this.handleCancel}
          >
            <Form layout="inline" className="settinghospital">
              <Form.Item label="医院名称" className="hospName">
                {getFieldDecorator("HOSPITAL_NAME", {
                  initialValue: rowData.HOSPITAL_NAME,
                  rules: [{ required: true, message: "请输入医院名称" }],
                })(<Input />)}
              </Form.Item>
              <Form.Item label="顺序判图模式">
                {getFieldDecorator("SEQUENCE_ANALYSIS", {
                  initialValue: rowData.SEQUENCE_ANALYSIS,
                  valuePropName: "checked",
                })(<Checkbox />)}
              </Form.Item>
              <Button onClick={this.onAdditionalInfoShow}>附加信息</Button>
              <div className="additionalInfo" style={{ width: this.state.showAdditionalInfo }}>
                <div
                  style={{
                    width: 780,
                    padding: 10,
                  }}
                >
                  <Divider orientation="left">医疗机构</Divider>
                  <div className="infoItem">
                    <Form.Item label="联系人">
                      {getFieldDecorator("MEDICAL_CONTACT", {
                        initialValue: rowData.ADDITIONAL_DATA?.MEDICAL_CONTACT,
                      })(<Input />)}
                    </Form.Item>
                    <Form.Item label="联系电话">
                      {getFieldDecorator("MEDICAL_TEL", {
                        initialValue: rowData.ADDITIONAL_DATA?.MEDICAL_TEL,
                        rules: [
                          {
                            message: "请输入正确的手机号！",
                            pattern:
                              /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/,
                          },
                        ],
                      })(<Input maxLength={11} />)}
                    </Form.Item>
                  </div>
                  <Divider orientation="left">经销商</Divider>
                  <div className="infoItem">
                    <Form.Item label="联系人">
                      {getFieldDecorator("DEALER_CONTACT", {
                        initialValue: rowData.ADDITIONAL_DATA?.DEALER_CONTACT,
                      })(<Input />)}
                    </Form.Item>
                    <Form.Item label="联系电话">
                      {getFieldDecorator("DEALER_TEL", {
                        initialValue: rowData.ADDITIONAL_DATA?.DEALER_TEL,
                        rules: [
                          {
                            message: "请输入正确的手机号！",
                            pattern:
                              /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/,
                          },
                        ],
                      })(<Input maxLength={11} />)}
                    </Form.Item>
                  </div>
                  <Divider orientation="left">安装时间</Divider>
                  <div className="infoItem">
                    <Form.Item label="静息心电">
                      {getFieldDecorator("ECG_INSTALL_DATE", {
                        initialValue: rowData.ADDITIONAL_DATA?.ECG_INSTALL_DATE
                          ? moment(rowData.ADDITIONAL_DATA?.ECG_INSTALL_DATE)
                          : undefined,
                      })(
                        <DatePicker
                          allowClear={false}
                          showToday={false}
                          renderExtraFooter={() => (
                            <Button onClick={this.clearDatePicker.bind(this, "ECG_INSTALL_DATE")}>清空</Button>
                          )}
                        />
                      )}
                    </Form.Item>
                    <Form.Item label="动态心电">
                      {getFieldDecorator("HOLTER_INSTALL_DATE", {
                        initialValue: rowData.ADDITIONAL_DATA?.HOLTER_INSTALL_DATE
                          ? moment(rowData.ADDITIONAL_DATA?.HOLTER_INSTALL_DATE)
                          : undefined,
                      })(
                        <DatePicker
                          allowClear={false}
                          showToday={false}
                          renderExtraFooter={(e) => (
                            <Button onClick={this.clearDatePicker.bind(this, "HOLTER_INSTALL_DATE", e)}>清空</Button>
                          )}
                        />
                      )}
                    </Form.Item>
                    <Form.Item label="动态血压">
                      {getFieldDecorator("BP_INSTALL_DATE", {
                        initialValue: rowData.ADDITIONAL_DATA?.BP_INSTALL_DATE
                          ? moment(rowData.ADDITIONAL_DATA?.BP_INSTALL_DATE)
                          : undefined,
                      })(
                        <DatePicker
                          allowClear={false}
                          showToday={false}
                          renderExtraFooter={() => (
                            <Button onClick={this.clearDatePicker.bind(this, "BP_INSTALL_DATE")}>清空</Button>
                          )}
                        />
                      )}
                    </Form.Item>
                  </div>
                  <Divider orientation="left">撤机时间</Divider>
                  <div className="infoItem">
                    <Form.Item label="静息心电">
                      {getFieldDecorator("ECG_WITHDRAWAL_DATE", {
                        initialValue: rowData.ADDITIONAL_DATA?.ECG_WITHDRAWAL_DATE
                          ? moment(rowData.ADDITIONAL_DATA?.ECG_WITHDRAWAL_DATE)
                          : undefined,
                      })(
                        <DatePicker
                          allowClear={false}
                          showToday={false}
                          renderExtraFooter={() => (
                            <Button onClick={this.clearDatePicker.bind(this, "ECG_WITHDRAWAL_DATE")}>清空</Button>
                          )}
                        />
                      )}
                    </Form.Item>
                    <Form.Item label="动态心电">
                      {getFieldDecorator("HOLTER_WITHDRAWAL_DATE", {
                        initialValue: rowData.ADDITIONAL_DATA?.HOLTER_WITHDRAWAL_DATE
                          ? moment(rowData.ADDITIONAL_DATA?.HOLTER_WITHDRAWAL_DATE)
                          : undefined,
                      })(
                        <DatePicker
                          allowClear={false}
                          showToday={false}
                          renderExtraFooter={(e) => (
                            <Button onClick={this.clearDatePicker.bind(this, "HOLTER_WITHDRAWAL_DATE", e)}>清空</Button>
                          )}
                        />
                      )}
                    </Form.Item>
                    <Form.Item label="动态血压">
                      {getFieldDecorator("BP_WITHDRAWAL_DATE", {
                        initialValue: rowData.ADDITIONAL_DATA?.BP_WITHDRAWAL_DATE
                          ? moment(rowData.ADDITIONAL_DATA?.BP_WITHDRAWAL_DATE)
                          : undefined,
                      })(
                        <DatePicker
                          allowClear={false}
                          showToday={false}
                          renderExtraFooter={() => (
                            <Button onClick={this.clearDatePicker.bind(this, "BP_WITHDRAWAL_DATE")}>清空</Button>
                          )}
                        />
                      )}
                    </Form.Item>
                  </div>
                  <Divider orientation="left">移机时间</Divider>
                  <div className="infoItem">
                    <Form.Item label="静息心电">
                      {getFieldDecorator("ECG_RELOCATION_DATE", {
                        initialValue: rowData.ADDITIONAL_DATA?.ECG_RELOCATION_DATE
                          ? moment(rowData.ADDITIONAL_DATA?.ECG_RELOCATION_DATE)
                          : undefined,
                      })(
                        <DatePicker
                          allowClear={false}
                          showToday={false}
                          renderExtraFooter={() => (
                            <Button onClick={this.clearDatePicker.bind(this, "ECG_RELOCATION_DATE")}>清空</Button>
                          )}
                        />
                      )}
                    </Form.Item>
                    <div className="addressBox">
                      <Form.Item label="移至地点">
                        {getFieldDecorator("ECG_RELOCATION_PLACE", {
                          initialValue: rowData.ADDITIONAL_DATA?.ECG_RELOCATION_PLACE,
                        })(<Input />)}
                      </Form.Item>
                    </div>
                  </div>
                  <div className="infoItem">
                    <Form.Item label="动态心电">
                      {getFieldDecorator("HOLTER_RELOCATION_DATE", {
                        initialValue: rowData.ADDITIONAL_DATA?.HOLTER_RELOCATION_DATE
                          ? moment(rowData.ADDITIONAL_DATA?.HOLTER_RELOCATION_DATE)
                          : undefined,
                      })(
                        <DatePicker
                          allowClear={false}
                          showToday={false}
                          renderExtraFooter={(e) => (
                            <Button onClick={this.clearDatePicker.bind(this, "HOLTER_RELOCATION_DATE", e)}>清空</Button>
                          )}
                        />
                      )}
                    </Form.Item>
                    <div className="addressBox">
                      <Form.Item label="移至地点">
                        {getFieldDecorator("HOLTER_RELOCATION_PLACE", {
                          initialValue: rowData.ADDITIONAL_DATA?.HOLTER_RELOCATION_PLACE,
                        })(<Input />)}
                      </Form.Item>
                    </div>
                  </div>
                  <div className="infoItem">
                    <Form.Item label="动态血压">
                      {getFieldDecorator("BP_RELOCATION_DATE", {
                        initialValue: rowData.ADDITIONAL_DATA?.BP_RELOCATION_DATE
                          ? moment(rowData.ADDITIONAL_DATA?.BP_RELOCATION_DATE)
                          : undefined,
                      })(
                        <DatePicker
                          allowClear={false}
                          showToday={false}
                          renderExtraFooter={() => (
                            <Button onClick={this.clearDatePicker.bind(this, "BP_RELOCATION_DATE")}>清空</Button>
                          )}
                        />
                      )}
                    </Form.Item>
                    <div className="addressBox">
                      <Form.Item label="移至地点">
                        {getFieldDecorator("BP_RELOCATION_PLACE", {
                          initialValue: rowData.ADDITIONAL_DATA?.BP_RELOCATION_PLACE,
                        })(<Input />)}
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </div>
              <Form.Item label="医院电话">
                {getFieldDecorator("HOSPITAL_TEL", {
                  initialValue: rowData.HOSPITAL_TEL,
                })(<Input />)}
              </Form.Item>
              <Form.Item label="医院类型">
                {getFieldDecorator("type", {
                  initialValue: typeArr,
                  rules: [{ required: true, message: "请选择医院类型" }],
                })(
                  <Checkbox.Group options={this.state.hospitalType} onChange={this.hospitalTypeChange}></Checkbox.Group>
                )}
              </Form.Item>
              <Form.Item label="医院等级">
                {getFieldDecorator("HOSPITAL_LEVEL", {
                  initialValue: rowData.HOSPITAL_LEVEL,
                })(
                  <Select style={{ width: "120px" }}>
                    <Option value="三级甲">三级甲</Option>
                    <Option value="三级乙">三级乙</Option>
                    <Option value="三级丙">三级丙</Option>
                    <Option value="二级甲">二级甲</Option>
                    <Option value="二级乙">二级乙</Option>
                    <Option value="二级丙">二级丙</Option>
                    <Option value="一级甲">一级甲</Option>
                    <Option value="一级乙">一级乙</Option>
                    <Option value="一级丙">一级丙</Option>
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="统计类型">
                {getFieldDecorator("STATISTICAL_TYPE", {
                  initialValue: rowData.STATISTICAL_TYPE,
                  rules: [{ required: true, message: "请选择统计类型" }],
                })(
                  <Select style={{ width: "200px" }}>
                    {typeArr.indexOf(1) !== -1 ? <Option value="申请医院">申请医院</Option> : null}
                    {typeArr.indexOf(2) !== -1 ? <Option value="会诊医院">会诊医院</Option> : null}
                    {typeArr.indexOf(1) !== -1 && typeArr.indexOf(2) !== -1 ? (
                      <Option value="监管机构">监管机构</Option>
                    ) : null}
                  </Select>
                )}
              </Form.Item>

              <Form.Item label="一级组别">
                {getFieldDecorator("firstGrouping", {
                  initialValue: rowData?.FIRST_GROUP_CODE?.split(",") || undefined,
                  rules: [{ required: true, message: "请选择一级组别" }],
                })(
                  <Select
                    mode="multiple"
                    optionFilterProp="children"
                    style={{ width: "200px" }}
                    onChange={this.getSecondGroupList}
                  >
                    {this.state.firstGroupList.map((item, index) => (
                      <Option key={item.FIRST_GROUP_CODE} value={item.FIRST_GROUP_CODE}>
                        {item.FIRST_GROUP_NAME}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="二级组别">
                {getFieldDecorator("secondGrouping", {
                  initialValue: rowData?.SECOND_GROUP_CODE?.split(",") || undefined,
                  rules: [{ required: true, message: "请选择二级组别" }],
                })(
                  <Select mode="multiple" optionFilterProp="children" style={{ width: "200px" }}>
                    {this.state.secondGroupList.map((item, index) => (
                      <Option key={item.SECOND_GROUP_CODE} value={item.SECOND_GROUP_CODE}>
                        {item.SECOND_GROUP_NAME}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>

              <Form.Item label="大屏展示">
                {getFieldDecorator("BELONG_GROUP", {
                  initialValue: rowData.BELONG_GROUP,
                  rules: [{ required: true, message: "请选择分组" }],
                })(
                  <Select style={{ width: "200px" }}>
                    {this.state.groupingArr.map((item, index) => (
                      <Option key={index} value={item}>
                        {item}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="检查项目">
                {getFieldDecorator("HOSPITAL_ITEM_DATA", {
                  initialValue: rowData.HOSPITAL_ITEM_DATA ? rowData.HOSPITAL_ITEM_DATA.split(",") : [],
                })(
                  <Select style={{ width: "200px" }} mode="multiple" optionFilterProp="children">
                    {this.state.hospitalItemList.map((item) => (
                      <Option key={item.EXAM_ITEM_CODE} value={item.EXAM_ITEM_CODE}>
                        {item.EXAM_ITEM_NAME}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>

              <Form.Item label="医院地址">
                {getFieldDecorator("HOSPITAL_ADDRESS", {
                  initialValue: rowData.HOSPITAL_ADDRESS,
                })(<Input />)}
              </Form.Item>
              <Form.Item label="医院简介">
                {getFieldDecorator("HOSPITAL_DESCRIPTION", {
                  initialValue: rowData.HOSPITAL_DESCRIPTION,
                })(<TextArea rows={4} style={{ width: "200px" }} />)}
              </Form.Item>
              <Form.Item label="菜单权限">
                {getFieldDecorator("PRIVILEGE_UID", {
                  initialValue: rowData.MENUMODULE_UID || [],
                  rules: [{ required: true, message: "请选择菜单权限" }],
                })(<Checkbox.Group onChange={this.handleCheckbox} options={powerMenuList}></Checkbox.Group>)}
              </Form.Item>
            </Form>
          </Modal>
        ) : null}
      </>
    );
  }
}

export default Form.create({})(SettingHospital);
